// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__KM2tz","footer":"Form_footer__3Vzi7"};